export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-lg text-white"></i>
              </span>
              <span className="text-lg font-bold font-heading text-white">
                吃瓜网站线路一
              </span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              51吃瓜官网全网最新入口，一站直达51吃瓜网址和吃瓜网站首页。每日更新海量吃瓜内容，是您收藏的首选吃瓜网站。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</a>
              <a href="#features" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">特色优势</a>
              <a href="#index" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">专题合集</a>
              <a href="#ranking" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热度榜</a>
              <a href="#faq" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">友情链接</h4>
            <nav className="flex flex-col gap-2">
              <a href="#topics" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">51吃瓜网站</a>
              <a href="#updates" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">吃瓜网站入口</a>
              <a href="#carousel" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">51吃瓜网址</a>
              <a href="#cards" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">吃瓜网站首页</a>
              <a href="#media" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">51吃瓜线路一</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} 吃瓜网站线路一 · 51吃瓜官网全网最新入口 · 保留所有权利
          </p>
          <p className="text-xs text-white/30">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}